// extracted by mini-css-extract-plugin
module.exports = {"AccountingAmountInput":"NetAmountField_AccountingAmountInput__1NN6U","VatAmountFieldContainer":"NetAmountField_VatAmountFieldContainer__5380t"};